<template>
  <div class="content-page">
    <div class="hd">
      <el-radio-group v-model="timeTabs" size="mini">
        <el-radio-button
          v-for="item in pickerOptions.shortcuts"
          :key="item.text"
          :label="item.value"
          >{{ item.text }}</el-radio-button
        >
      </el-radio-group>
      <el-date-picker
        size="mini"
        v-model="orderTime"
        type="daterange"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        @change="orderTimeChange"
      >
      </el-date-picker>
    </div>
    <div class="bd">
      <div class="row">
        <div class="item">
          <div class="info">
            <p class="title">线上总额</p>
            <strong class="num">{{
              list.total_online_recharge ? list.total_online_recharge.toFixed(2) : 0
            }}</strong>
          </div>
        </div>
        <div class="item">
          <div class="info">
            <p class="title">现金总额</p>
            <strong class="num">{{
              list.total_cash_recharge ? list.total_cash_recharge.toFixed(2) : 0
            }}</strong>
          </div>
        </div>
        <div class="item">
          <div class="info">
            <p class="title">返现总额</p>
            <strong class="num"
              >{{
              list.total_cash_back ? list.total_cash_back.toFixed(2) : 0
            }}</strong
            >
          </div>
        </div>
        <div class="item">
          <div class="info">
            <p class="title">充值总额</p>
            <strong class="num">{{
              list.total_recharge ? list.total_recharge.toFixed(2) : 0
            }}</strong>
          </div>
        </div>
        <div class="item">
          <div class="info">
            <p class="title">消费总额</p>
            <strong class="num">{{
              list.total_consume ? list.total_consume.toFixed(2) : 0
            }}</strong>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getShopMemberData2
} from "@/api/index.js";
export default {
  data() {
    return {
      list: {},
      orderTime: [new Date().getTime() - 3600 * 1000 * 24 * 6, new Date()],
      timeTabs: "week",
      pickerOptions: {
        shortcuts: [
          {
            text: "今日",
            value: "today",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 0);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "近7日",
            value: "week",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 6);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "近30日",
            value: "month",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 29);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "近90日",
            value: "quarter",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 89);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      dates: [],
    };
  },
  watch: {
    timeTabs(value) {
      const end = new Date();
      const start = new Date();
      if (value == "today") {
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 0);
        this.orderTime = [start, end];
      }
      if (value == "week") {
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 6);
        this.orderTime = [start, end];
      }
      if (value == "month") {
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 29);
        this.orderTime = [start, end];
      }
      if (value == "quarter") {
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 89);
        this.orderTime = [start, end];
      }
      this.getShopMemberData2();
    },
  },
  mounted() {
    this.getShopMemberData2();
  },
  methods: {
    getShopMemberData2() {
      let begin = new Date(this.orderTime[0]).pattern("yyyy-MM-dd");
      let end = new Date(this.orderTime[1]).pattern("yyyy-MM-dd");
      this.dates = this.getAll(begin, end);
      getShopMemberData2({
        startDate: this.orderTime[0]
          ? new Date(this.orderTime[0]).pattern("yyyy-MM-dd")
          : "",
        endDate: this.orderTime[1]
          ? new Date(this.orderTime[1]).pattern("yyyy-MM-dd")
          : "",
        shopStoreId: localStorage.shopStoreId,
      }).then((res) => {
        if (res.code == 1) {
          this.list = res.data
        } else {
          this.$notify({
            title: "提示",
            message: res.msg,
            type: "error",
            duration: 2000,
          });
        }
      });
    },
    getAll(begin, end) {
      var arr = [];
      var ab = begin.split("-");
      var ae = end.split("-");
      var db = new Date();
      db.setUTCFullYear(ab[0], ab[1] - 1, ab[2]);
      var de = new Date();
      de.setUTCFullYear(ae[0], ae[1] - 1, ae[2]);
      var unixDb = db.getTime() - 24 * 60 * 60 * 1000;
      var unixDe = de.getTime() - 24 * 60 * 60 * 1000;
      for (var k = unixDb; k <= unixDe; ) {
        //console.log((new Date(parseInt(k))).format());
        k = k + 24 * 60 * 60 * 1000;
        arr.push(new Date(parseInt(k)).format());
      }
      //console.log(JSON.stringify(arr));
      return arr;
    },
    orderTimeChange(e) {
      this.getShopMemberData2();
      this.timeTabs = ""
    },
  },
};
</script>

<style lang="less" scoped>
.content-page {
  overflow: hidden;
  .hd {
    padding: 20px 0 0 20px;
    .el-radio-group {
      margin-right: 10px;
    }
  }
  .bd {
    height: 100%;
  }
  .icon {
    text-align: center;
    color: #fff;
    &.circle {
      width: 45px;
      height: 45px;
      line-height: 45px;
      border-radius: 50%;
      &.iconfont {
        font-size: 22px;
      }
    }
    &.rect {
      width: 20px;
      height: 20px;
      line-height: 20px;
      border-radius: 4px;
      &.iconfont {
        font-size: 12px;
      }
    }
    &.blue {
      background: #409eff;
    }
    &.red {
      background: #f56c6c;
    }
    &.green {
      background: #67c23a;
    }
    &.yellow {
      background: #ffa51e;
    }
  }
  .overview {
    & > .title {
      padding-left: 20px;
      font-size: 22px;
      font-weight: 600;
    }
  }
  .row {
    display: flex;
    .item {
      flex: 1;
      display: flex;
      padding-left: 20px;
      margin: 37px 0 39px;
      cursor: default;
      .info {
        // margin-left: 18px;
        .title {
          font-size: 12px;
          line-height: 12px;
          color: #666666;
          margin-top: 2px;
          margin-bottom: 10px;
          .el-link {
            margin-left: 10px;
            font-size: 12px;
            vertical-align: inherit;
          }
        }
        .num {
          font-size: 18px;
          line-height: 18px;
          color: #333333;
        }
      }
    }
  }
  .tab-header {
    height: 72px;
    line-height: 42px;
    box-sizing: border-box;
    border-bottom: 0;
    .top {
      display: flex;
      margin-bottom: 20px;
      white-space: nowrap;
      .top-item {
        display: flex;
        flex: 1;
        align-items: center;
        margin-right: 66px;
        span {
          white-space: nowrap;
          margin-right: 10px;
          font-size: 12px;
          color: #333333;
          font-weight: bold;
        }
        .el-select {
          width: 100%;
        }
      }
    }
  }
  .tab-content {
    display: block;
    padding: 0;
    height: calc(100% - 124px);
  }
}
</style>

<style lang="less">
.right {
  .el-progress__text {
    color: #e99322;
  }
}
.echarts,
.e-charts {
  width: 100%;
}
</style>
